import { Flex, Text } from '@skin-seoul/design-system';
import { getDiscountPercentage } from '@skin-seoul/service';

import { useProductCard } from '../ProductCardContext';

export const DiscountBadge = () => {
  const { originalPrice, salePrice } = useProductCard();
  const discountPercentage = getDiscountPercentage(originalPrice, salePrice);

  if (discountPercentage <= 0) return null;

  return (
    <Flex
      position="absolute"
      top={0}
      left={0}
      zIndex={3}
      backgroundColor="primary.400"
      paddingX="6px"
      paddingY="2px"
      borderTopLeftRadius="8px"
      borderBottomRightRadius="8px"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        color="generic.0"
        textStyle="label.medium"
        fontWeight="medium"
        whiteSpace="nowrap"
      >
        {discountPercentage}% off
      </Text>
    </Flex>
  );
};
